export const DEFAULT_MENU_PLATFORM_FEE_PCT = 0.15;

export function platformFeeFromCafePrice(
  cafePrice: number,
  pct = DEFAULT_MENU_PLATFORM_FEE_PCT
): number {
  return Math.round(Math.max(0, cafePrice) * pct * 100) / 100;
}

export function customerTotalFromCafePrice(
  cafePrice: number,
  pct = DEFAULT_MENU_PLATFORM_FEE_PCT
): number {
  return Math.round(Math.max(0, cafePrice) * (1 + pct) * 100) / 100;
}

export function cafePriceFromCustomerTotal(
  customerTotal: number,
  pct = DEFAULT_MENU_PLATFORM_FEE_PCT
): number {
  if (customerTotal <= 0) return 0;
  return Math.round((customerTotal / (1 + pct)) * 100) / 100;
}
